import { h, Component, Fragment } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { isEmptyObject, isDesktop, isMobile, capitalizeFirstLetter, replaceFilter, replaceCleaner } from '../../js/modules/utilities.js'
import { OccasionnelONews } from '../../components/occasionnel-onews/occasionnel-onews.jsx'
import { attachClampByQuery } from '../../js/modules/clamp.js'

export const News = (props) => {
   useLayoutEffect(() => {
      attachClampByQuery('#newsFeedContainer [data-clamp-line]')
   }, [])
   return isMobile() ? <NewsMobile {...props} /> : <NewsDesktop {...props} />
}

class NewsDesktop extends Component {
   constructor(props) {
      super(props)
      this.state = {
         ...props,
      }
      document.addEventListener('newsPublicite', (e) => {
         if (e.detail.autopromo) {
            this.setState((publicite.autopromo = e.detail.autopromo))
         }
      })
   }

   render() {
      const { title, menu, meteo, publicite, classes, sliders, filInfo, pasDePorte, allNewsButton } = this.state
      return (
         <div class="container-fluid">
            <div class={`row mb-3 o-news mt-1 ${classes}`} id="oNews" data-testid="bande-news">
               <div class="col-6 col-lg-8 js-onews-left">
                  <div class="row">
                     <div class="col-12 d-flex align-items-baseline onews-menu" data-testid="news-menu">
                        <Titre {...title} />
                        <Menu {...menu} />
                     </div>

                     <h2 class="sr-only">Les news du moment</h2>

                     {sliders.map((item) => (
                        <SliderDesktop {...item} />
                     ))}

                     <AllNewsButton {...allNewsButton} />
                  </div>
               </div>

               <div id="totemColumn" class="col-6 col-lg-4 totemColumn position-relative">
                  <div class="totemContent">
                     <div>
                        <PubliciteDesktop {...publicite} />
                        <Meteo {...meteo} />
                     </div>

                     <div class="containerFilInfo">
                        <FilInfo {...filInfo} />
                     </div>

                     <PasDePorte {...pasDePorte} />
                  </div>
               </div>
            </div>
         </div>
      )
   }
}

class NewsMobile extends Component {
   constructor(props) {
      super(props)
      this.state = {
         ...props,
      }
   }

   render() {
      const { title, menu, meteo, publicite, classes, sliders, filInfo, pasDePorte, allNewsButton } = this.state
      return (
         <div class="container-fluid">
            <div class="row o-news" id="oNews" data-testid="bande-news">
               <div class="col-12">
                  <h2 class="mb-1">News</h2>
               </div>

               {sliders.map((item) => (
                  <SliderMobile {...item} />
               ))}
               <PubliciteMobile {...publicite} />
            </div>

            <div class="row">
               <div class="col-12">
                  <h3 class="mb-0">Infos en direct</h3>
                  <FilInfo {...filInfo} />
               </div>

               <div class="col-12">
                  <div class="d-flex justify-content-between justify-content-sm-around sm-smallBlocks">
                     <Meteo {...meteo} />
                  </div>
               </div>

               <AllNewsButton {...allNewsButton} />
            </div>
         </div>
      )
   }
}

const Titre = (props) => {
   const { href, analytics, label, large_title_spaces } = props
   return (
      <div class={`h2 no-signature mr-2 mr-xl-3 ${large_title_spaces ? 'mb-2 mb-xl-3' : 'mb-1'}`}>
         <a href={href} data-oevent-category={analytics.category} data-oevent-action={analytics.action} data-oevent-label={analytics.label} data-oevent-other={analytics.other}>
            {label}
         </a>
      </div>
   )
}

const Menu = (props) => {
   const { text, events } = props
   return (
      <nav class="w-100" role="navigation" aria-label="News">
         <ul class="block-title overflow-hidden mb-0 block-title__fixed" id="oNews_menu">
            {text.map((data, index) => (
               <li class="block-title-item d-none d-lg-inline-block" data-testid={`news-menu-text${index}`}>
                  <a
                     href={data.url}
                     class="title"
                     data-oevent-category={data.analytics.category}
                     data-oevent-action={data.analytics.action}
                     data-oevent-label={data.analytics.label}
                     data-oevent-other={data.analytics.other}
                  >
                     {data.title}
                  </a>
               </li>
            ))}
            {events.map((data, index) => (
               <li class="block-title-item d-inline-block" data-testid="news-menu-icon" data-cache-key={data.cacheKey}>
                  <a
                     href={data.url}
                     class="title"
                     title={data.title}
                     target={data.target}
                     data-oevent-category={data.analytics.category}
                     data-oevent-action={data.analytics.action}
                     data-oevent-label={data.analytics.label}
                     data-oevent-other={data.analytics.other}
                     data-pdb-zid={data.analytics.pdbZid}
                     data-pdb-sc={data.analytics.pdbSc}
                     data-pdb-idc={data.analytics.pdbIdc}
                     data-pdb-vi={data.analytics.pdbVi}
                  >
                     {data.image == '' ? data.title : <img loading="lazy" src={data.image} alt={data.alt} />}
                  </a>
               </li>
            ))}
         </ul>
      </nav>
   )
}

const AllNewsButton = (props) => {
   const { url, label, analytics } = props
   return isMobile() ? (
      <div class="col-12 mb-2 mt-2 d-flex justify-content-center">
         <a
            href={url}
            class="btn btn-secondary"
            data-testid="news-voir-toutes"
            data-oevent-category={analytics.category}
            data-oevent-action={analytics.action}
            data-oevent-label={analytics.label}
            data-oevent-other={analytics.other}
         >
            {label}
         </a>
      </div>
   ) : (
      <div class="col-12 d-flex justify-content-center js-onews-left-cta">
         <a
            href={url}
            class="btn btn-secondary mt-1 mt-xl-2"
            data-testid="news-voir-toutes"
            data-oevent-category={analytics.category}
            data-oevent-action={analytics.action}
            data-oevent-label={analytics.label}
            data-oevent-other={analytics.other}
         >
            {label}
         </a>
      </div>
   )
}

const PubliciteDesktop = (props) => {
   if (!isEmptyObject(props)) {
      const { autopromo, adgateway, nativeAds } = props
      const autopromoArray = [autopromo] // temporaire
      return (
         <Fragment>
            {/* Pub native ads */}
            <div id={`oan_ora_1_1x1_hp.${nativeAds.segmentation}`}></div>

            {/* Pub Autopromo advise */}
            {!isEmptyObject(autopromo) && typeof autopromo !== 'undefined' ? (
               <div id="zone_news_foisonnement-b" class="foisonnement-onews" data-testid="zone-foisonnement-b">
                  <OccasionnelONews {...autopromoArray} />
               </div>
            ) : (
               ''
            )}

            {/* Pub RM adgateway */}
            {!isEmptyObject(adgateway) && typeof adgateway !== 'undefined' ? (
               <div id={`oan_ora_${adgateway.id}${adgateway.deviceType}_300x250_hp.${adgateway.segmentation}`} class="tag-rm"></div>
            ) : (
               ''
            )}
         </Fragment>
      )
   } else {
      return ''
   }
}

const PubliciteMobile = (props) => {
   const { adgateway } = props
   return (
      <div class="col-12 col-sm-6 mb-1">
         <div class="tuile o-media-mobile d-none native-news-container">
            <a href="#" title="" class="onews-reference native-news-link w-100">
               <div class="main-wrapper">
                  <div class="wrapper">
                     <div>
                        <img loading="lazy" alt="" class="image native-news-picture" />
                     </div>
                  </div>
                  <div class="wrapper text-secondary js-news-thumb native-news-wrapper-content position-relative">
                     <h3 class="category standard text-gray3 d-block py-0 my-0 text-truncate native-news-category"></h3>
                     <strong data-clamp-line="3" class="title lead font-weight-bold m-0 native-news-title"></strong>
                  </div>
               </div>
            </a>
         </div>
         <div id={`oan_ora_1m_1x1_hp.${adgateway.segmentation}`}></div>
      </div>
   )
}

const Meteo = (props) => {
   const { url, analytics, text } = props
   return (
      <a
         class="meteo-ville"
         data-testid="news-meteo"
         href={url}
         data-oevent-category={analytics.category}
         data-oevent-action={analytics.action}
         data-oevent-label={analytics.label}
         data-oevent-other={analytics.other}
      >
         <svg class="svg-meteo" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 1000 1000">
            <path d="M867.522,571.935a258.246,258.246,0,0,0,5.775-54.374c0-142.4-115.667-257.831-258.351-257.831A258.038,258.038,0,0,0,413.8,355.776,105.8,105.8,0,0,0,286.64,448.642c-92.928,11.311-164.91,90.319-164.91,186.115,0,103.561,84.122,187.513,187.892,187.513H779.351c77.828,0,140.919-62.964,140.919-140.635A140.259,140.259,0,0,0,867.522,571.935ZM670.6,640.56V392.145a44.1,44.1,0,1,0-88.194,0v14.717h22.049a7.359,7.359,0,0,1,0,14.717H582.4V436.3h22.049a7.359,7.359,0,0,1,0,14.717H582.4v14.717h22.049a7.358,7.358,0,0,1,0,14.716H582.4V640.56A73.5,73.5,0,1,0,670.6,640.56ZM626.5,743.58a44.162,44.162,0,0,1-22.342-82.218v-145.6a22.343,22.343,0,1,1,44.685,0v145.6A44.163,44.163,0,0,1,626.5,743.58ZM174.118,464.929c-0.075-2.183-.127-4.372-0.127-6.573,0-103.5,83.939-187.406,187.484-187.406a186.8,186.8,0,0,1,79.972,17.869A279.118,279.118,0,0,1,513,248.83l-8.622-39.406-84.051,26.754L360.919,171l-59.408,65.178-84.052-26.754-18.846,86.138L112.44,314.4l26.765,84.017L74,457.8,131.317,510A212.524,212.524,0,0,1,174.118,464.929Z" />
         </svg>
         <span class="o-link-arrow">{text}</span>
      </a>
   )
}

const FilInfo = (props) => {
   const { news, title } = props
   const duration = (4 + 0.3) * news.length
   const styleAnimation = {
      animationName: 'ticker',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationFillMode: 'none',
      animationDuration: `${duration}s`,
   }
   return (
      <Fragment>
         {isDesktop() ? <h3 class="sr-only">{title}</h3> : ''}
         <div id="newsFeedContainer" class="newsfeed" data-testid="fil-info">
            <ul
               style={isDesktop() ? styleAnimation : ''}
               class={`${isDesktop() ? 'bg-gray2 px-2 newsFilInfoAnimate' : 'mobile bg-white'} list-group list-group-flush listeActu js-resizable`}
               id="newsFilInfo"
            >
               <FilInfoList news={news} />
               {!isMobile() ? <FilInfoList news={news} shadow={true} /> : ''}
            </ul>
         </div>
      </Fragment>
   )
}

const FilInfoList = (props) => {
   const { news, shadow } = props
   return (
      <Fragment>
         {news.map((info, index) => (
            <li id={`${!shadow ? `newsticker${index + 1}` : ''}`} class={`${isDesktop() ? 'bg-gray2' : 'bg-white'} list-group-item flex-column align-items-center py-1 px-0`}>
               <a
                  href={info.url}
                  title={info.title}
                  class="standard px-0 news-fil-info-link"
                  tabindex={shadow ? '-1' : null}
                  aria-hidden={shadow ? 'true' : null}
                  data-oevent-category={info.analytics.category}
                  data-oevent-action={info.analytics.action}
                  data-oevent-label={info.analytics.label}
                  data-oevent-other={info.analytics.other}
               >
                  <div class="news-fil-info-wrap d-flex w-100">
                     <span class={`${isDesktop() ? 'pr-2' : 'pr-1'} align-self-center news-fil-info-date`}>{info.time}</span>
                     <span class="news-fil-info-title" data-clamp-line={`${isDesktop() ? '2' : '1'}`}>
                        <span class="title-cat mb-0">
                           <strong>{capitalizeFirstLetter(info.category)}</strong>
                        </span>{' '}
                        - <span class="desc">{info.title}</span>
                     </span>
                  </div>
               </a>
            </li>
         ))}
      </Fragment>
   )
}

const PasDePorte = (props) => {
   const { ads, cacheKey } = props
   const ad = ads[0] //temporaire le temps que le back ne remonte qu'un element
   return (
      <div class="mt-2 js-fixed" data-cache-key={cacheKey}>
         <a
            href={ad.url}
            title={`${replaceCleaner(ad.title)}`}
            class="pasDePorte"
            data-testid={`pas-de-porte`}
            target={ad.target ? '_blank' : ''}
            data-oevent-category={ad.analytics.category}
            data-oevent-action={ad.analytics.action}
            data-oevent-label={ad.analytics.label}
            data-oevent-other={ad.analytics.other}
         >
            <img src={`${ad.image}&format=100x100`} alt="" height="50" width="50" loading="lazy" />
            <h3 class="pasDePorte_title" dangerouslySetInnerHTML={{ __html: replaceFilter(ad.title) }}></h3>
         </a>
      </div>
   )
}

const SliderDesktop = (props) => {
   const { vignettes, name, refId, title, cacheKey } = props
   return (
      <div class="col-12 col-lg-6" data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile mb-2 o-media glide glide-slider ${name} ${name === 'o-news-focus' ? 'native-news-container' : ''}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {vignettes.map((item, index) => (
                     <VignetteDesktop {...item} index={index + 1} nbItems={vignettes.length} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteDesktop = (props) => {
   const { isNative, categoryTitle, url, title, target, image, analytics, newsline, index, nbItems, navigation } = props

   return (
      <li class="glide__slide slick-slide">
         <div
            class={`onews-reference lien-composite ${isNative ? 'native-news-link' : ''}`}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.category}
            data-oevent-action={analytics.action}
            data-oevent-label={analytics.label}
            data-oevent-other={analytics.other}
         >
            <div class="pt-1">
               <div class="wrapper bg-gray2 pb-1 mr-1">
                  <picture class={`ml-1 mt--1 mr--1 wrapper-image w-100 ${isNative ? 'native-news-picture' : ''}`}>
                     <source srcset={`${image}&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}&format=420x`} alt="" aria-hidden="true" class=" image w-100" />
                  </picture>
               </div>
               <div class={`wrapper bg-gray2 px-1 pb-1 mr-1 text-secondary js-news-line${newsline}`} data-sameheight-active="(min-width: 960px)">
                  <span class={`category standard font-weight-bold text-gray3 d-block py-0 my-0 ${isNative ? 'native-news-category' : ''}`}>{categoryTitle}</span>
                  <a href={url} target={target}>
                     <h4 data-clamp-line="3" class={`title lead font-weight-bold m-0 pb-0 ${isNative ? 'native-news-title' : ''}`}>
                        {title}
                     </h4>
                  </a>
                  <div class="pagination-news" data-glide-el="controls" aria-hidden="true">
                     <span
                        class="prev-news icon-arrow-previous"
                        title={navigation.previous.title}
                        data-glide-dir="<"
                        data-oevent-category={navigation.previous.analytics.category}
                        data-oevent-action={navigation.previous.analytics.action}
                        data-oevent-label={navigation.previous.analytics.label}
                        data-oevent-other={navigation.previous.analytics.other}
                     ></span>
                     <div class="paging">
                        <strong>{index}</strong> / {nbItems}
                     </div>
                     <span
                        class="next-news icon-arrow-next"
                        title={navigation.previous.title}
                        data-glide-dir=">"
                        data-oevent-category={navigation.next.analytics.category}
                        data-oevent-action={navigation.next.analytics.action}
                        data-oevent-label={navigation.next.analytics.label}
                        data-oevent-other={navigation.next.analytics.other}
                     ></span>
                  </div>
               </div>
            </div>
         </div>
      </li>
   )
}

const SliderMobile = (props) => {
   const { vignettes, title, name, cacheKey } = props
   return (
      <div class="col-12 col-sm-6 mb-1" data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile o-media-mobile glide glide-slider ${name}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {vignettes.map((item, index) => (
                     <VignetteMobile {...item} index={index + 1} nbItems={vignettes.length} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteMobile = (props) => {
   const { isNative, categoryTitle, url, title, target, image, analytics, newsline, index, nbItems, navigation } = props

   return (
      <li class="glide__slide">
         <div
            class="onews-reference lien-composite"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.category}
            data-oevent-action={analytics.action}
            data-oevent-label={analytics.label}
            data-oevent-other={analytics.other}
         >
            <div class="main-wrapper">
               <div class="wrapper">
                  <picture>
                     <source srcset={`${image}&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}&format=420x`} alt="" aria-hidden="true" class="image" />
                  </picture>
               </div>

               <div class="wrapper text-secondary js-news-thumb" data-sameheight-active="(min-width: 480px)">
                  <span class="category standard font-weight-bold text-gray3 d-block py-0 my-0 text-truncate">{categoryTitle}</span>
                  <a href={url} target={target}>
                     <h4 data-clamp-line="3" class="title lead font-weight-bold m-0 pb-0">
                        {title}
                     </h4>
                  </a>
               </div>
            </div>
         </div>
      </li>
   )
}
